// extracted by mini-css-extract-plugin
export var fullGrid = "_2j-3";
export var pdpPreviewContainer = "_2j-1";
export var previewContainer = "_2j-0";
export var togglePreviewContainer = "_2j-2";